import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qyxxvd286n: FaireBrandEntity = {
  token: "b_qyxxvd286n",
  type: "brand",
  name: "jiomind",
  avatarUrl:
    "https://cdn.faire.com/fastly/2fdb508f07f61e270c42d2110914fecdcd2d1bb322a2c1dcab81686ffec9efb4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b01f25b91989ba268f323eab3fe51c06c123e2ed498af33d5b88145ae52ade69.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2fdb508f07f61e270c42d2110914fecdcd2d1bb322a2c1dcab81686ffec9efb4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b01f25b91989ba268f323eab3fe51c06c123e2ed498af33d5b88145ae52ade69.jpeg",
  location: "Markham, ON, CAN",
  minimumOrderDollars: 173,
  rating: 4.7,
  reviewCount: 25,
  isInsider: false,
  description:
    "NO TARIFF ON SHIPMENTS TO USA. We will PRE-PAY the Tarif to the US shipments. Buyers will not required to pay any Tariff/Duties.\n\nJiomind  was created with the mission to help others transform their lives in body, mind & spirit for a more fulfilling life. Life is very hectic and stressful. Our energy jewelry assists those who believe in themselves and in spiritual, emotional, physical healing. Our jewelry is hand crafted with love, care & positive energy. Each stone provides its own healing abilities for the mind, body, and soul. The gemstones and crystals accelerate energy patterns which combine their natural power with the inner strength of your desires. They are believed to promote the flow of good energy and help rid the body and mind of negative energy for physical and emotional benefits.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:55.090Z",
    importedBy: "entity-db-cli",
  },
};
